import React from 'react';
import { Container } from 'reactstrap';
import PermissionView from './Components/PermissionView';

const Permission = () => {
  document.title = 'Permission Management';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid className='px-0'>
          <PermissionView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Permission;
